import { render, staticRenderFns } from "./ConfigurarLandingModalNuevo.vue?vue&type=template&id=1022244d&scoped=true&"
import script from "./ConfigurarLandingModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLandingModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarLandingModalNuevo.vue?vue&type=style&index=0&id=1022244d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1022244d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1022244d', component.options)
    } else {
      api.reload('1022244d', component.options)
    }
    module.hot.accept("./ConfigurarLandingModalNuevo.vue?vue&type=template&id=1022244d&scoped=true&", function () {
      api.rerender('1022244d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarLanding/ConfigurarLandingModalNuevo.vue"
export default component.exports